import React from 'react';

const Services2 = () => {
    return (

    <section id="servicesLayout2" className="services services-layout2 pt-120 pb-90 bg-gray">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-8 offset-lg-2">
            <div className="heading heading-2 text-center mb-40">
              <span className="heading__subtitle">Technical Industrial Solutions</span>
              <h2 className="heading__title">Evermore Limited has 23+ years of experience with providing wide area of specialty services works listed below.</h2>
            </div>{/* /.heading */}
          </div>{/* /.col-lg-10 */}
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-lg-4">
            <div className="service-item">
              <div className="service__content">
                <div className="service__icon"><i className="icon-tank-2" /></div>
                <h4 className="service__title">Integrated Facilities  <br /> Solutions</h4>
                <p className="service__desc">As an Integrated Facility Service provider we manage all service deliveries, administration, training, operational...</p>
                <a href="/#" className="btn btn__secondary btn__link">
                  <span>Read More</span>
                  <i className="icon-arrow-right" />
                </a>
              </div>{/* /.service-content */}
            </div>{/* /.service-item */}
          </div>{/* /.col-lg-4 */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <div className="service-item">
              <div className="service__content">
                <div className="service__icon"><i className="icon-manufacturing-plant" /></div>
                <h4 className="service__title">Property Management  <br /> Services</h4>
                <p className="service__desc">We have the system, process, and qualified, dedicated service professionals required to manage the life cycle of all facilities...</p>
                <a href="/#" className="btn btn__secondary btn__link">
                  <span>Read More</span>
                  <i className="icon-arrow-right" />
                </a>
              </div>{/* /.service-content */}
            </div>{/* /.service-item */}
          </div>{/* /.col-lg-4 */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <div className="service-item">
              <div className="service__content">
                <div className="service__icon"><i className="icon-factory-2" /></div>
                <h4 className="service__title">Project Management</h4>
                <p className="service__desc">Evermore is result driven, and we believe that clients want to see an appreciable amount of performance in terms of quality ...</p>
                <a href="/#" className="btn btn__secondary btn__link">
                  <span>Read More</span>
                  <i className="icon-arrow-right" />
                </a>
              </div>{/* /.service-content */}
            </div>{/* /.service-item */}
          </div>{/* /.col-lg-4 */}
        </div>{/* /.row*/}
      </div>{/* /.container */}
    </section>
  );
}

export default Services2;